// src/gestion-logistics/components/StatusBadge.tsx
import React from "react";
import { Tag } from "antd";
import {
  FileOutlined,
  CheckCircleOutlined,
  RocketOutlined,
  CarOutlined,
  CheckOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { ShipmentStatus } from "../types/shipment.types";

interface StatusBadgeProps {
  status: ShipmentStatus;
  color?: string;
  size?: "small" | "default";
}

/**
 * Composant pour afficher un badge de statut de dossier
 * Utilise les couleurs et icônes appropriées selon le statut
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = "default", color }) => {
  const getStatusConfig = () => {
    switch (status) {
      case ShipmentStatus.DRAFT:
        return {
          color: "default",
          icon: <FileOutlined />,
          text: "Brouillon",
        };
      case ShipmentStatus.CONFIRMED:
        return {
          color: "blue",
          icon: <CheckCircleOutlined />,
          text: "Confirmé",
        };
      case ShipmentStatus.IN_TRANSIT:
        return {
          color: "orange",
          icon: <CarOutlined />,
          text: "En Transit",
        };
      case ShipmentStatus.DELIVERED:
        return {
          color: "cyan",
          icon: <RocketOutlined />,
          text: "Livré",
        };
      case ShipmentStatus.COMPLETED:
        return {
          color: "green",
          icon: <CheckOutlined />,
          text: "Terminé",
        };
      case ShipmentStatus.CANCELLED:
        return {
          color: "red",
          icon: <CloseCircleOutlined />,
          text: "Annulé",
        };
      default:
        return {
          color: "default",
          icon: <FileOutlined />,
          text: status,
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Tag
      color={color || config.color}
      icon={config.icon}
      style={{
        fontSize: size === "small" ? "12px" : "14px",
        padding: size === "small" ? "2px 8px" : "4px 12px",
      }}
    >
      {config.text}
    </Tag>
  );
};

export default StatusBadge;
